export const correlation = {
    centerLabel: {
        visible: !0,
        position: "center",
        style: {
            fill: "#fff",
            text: ""
        }
    },
    label: {
        visible: !0,
        position: "bottom",
        style: {
            fill: "#000"
        }
    }
};
//# sourceMappingURL=correlation.js.map
